import { defaultAnimations } from './defaultAnimations';

export default class AnimationTune {
  static get isTune() {
    return true;
  }

  /**
  *
  * @param api
  * @param data
  * @param settings
  * @param block
  */
  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;
    this.animations = defaultAnimations();

    if (this.settings.animations && this.settings.animations.length > 0) {
      this.animations = this.settings.animations;
    }

    this.data = {
      animation: this.animations[0]
    };

    if (data && data.animation && data.animation.class) {
      this.data = {
        animation: data.animation
      };
    }

    this._CSS = {
      wrapper: 'cdx-animations-settings',
      select: 'cdx-settings-select',
      tuneWrapper: 'editor-block-tune',
      tuneTitle: 'editor-block-tune-title',
      tuneText: 'editor-block-tune-text',
      tuneInput: 'editor-block-tune-input',
      // fragment: 'fragment',
    };
  }

  /**
    * rendering block tune
    * @returns {*}
    */
  render() {
    const { animation } = this.data;

    const wrapper = document.createElement('div');
    const title = document.createElement('label');
    const selectContainer = document.createElement('div');
    const select = document.createElement('select');

    wrapper.classList.add(this._CSS.wrapper, this._CSS.tuneWrapper);
    title.classList.add(this._CSS.tuneTitle);
    selectContainer.classList.add('select-container');
    select.classList.add(this._CSS.select,this._CSS.tuneInput);
    select.setAttribute('name', 'animation');

    title.innerText = 'Animation';

    this.animations.forEach((animationItem, index) => {
      const option = document.createElement('option');
      option.setAttribute('value', animationItem.class);
      option.innerHTML = animationItem.label;

      if (animationItem.class === animation.class) {
        option.setAttribute('selected', true);
      }

      select.appendChild(option);
    });

    select.addEventListener('change', () => {
      const value = select.value;
      let animationItem;

      this.animations.forEach(item => {
        if (item.class === value) {
          animationItem = item;
        }
      });

      this.data = {
        animation: animationItem
      };

      this.block.dispatchChange();
    });

    selectContainer.appendChild(select);
    wrapper.appendChild(title);
    wrapper.appendChild(selectContainer);
    return wrapper;
  }
  /**
  * save
  * @returns {*}
  */
  save() {
    return this.data;
  }
};